import { get } from "shared/data";
import { sortShots } from "components/photography/lib/helpers";

export const getShots = (wipKey) => {
    return get(`/photography/wips/${wipKey}/shots?isActive=true`);
};

export const preferredShot = (shots) => {
    if (!shots || shots.length === 0) {
        return false;
    }

    const useShots = shots.sort(sortShots);
    const smartFormatView = useShots.find(({ imageView }) => imageView === "SLF");
    const ecomView = useShots.find(({ imageView }) => imageView === "Ecom");
    const defaultEcomView = useShots.find(({ isDefaultEcomShot }) => isDefaultEcomShot);
    const sm1View = useShots.find(({ imageView }) => imageView === "SM 1");

    if (smartFormatView) {
        return smartFormatView;
    } else if (sm1View) {
        return sm1View;
    } else if (defaultEcomView) {
        return defaultEcomView;
    } else if (ecomView) {
        return ecomView;
    } else {
        const [firstShot] = useShots;

        return firstShot;
    }
};

export const getUneditedFallback = (shots, hasEditedShots) => {
    const editedImageUris = "editedImageUris";
    const uneditedImageUris = "uneditedImageUris";
    const imageUris = hasEditedShots ? editedImageUris : uneditedImageUris;
    const filteredShots = shots.filter((img) => !!img[imageUris]);

    if (hasEditedShots && filteredShots.length === 0) {
        const uneditedFallback = shots.filter((img) => !!img[uneditedImageUris]);

        const shot = preferredShot(uneditedFallback);

        return shot ? shot[uneditedImageUris] : "";
    }

    const shot = preferredShot(filteredShots);

    return shot ? shot[imageUris] : "";
};
